var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex position-relative overflow-auto px-3"},[(_vm.loading)?_c('big-spinner'):(_vm.failedToLoad)?_c('failed-to-load-remote-content'):_c('div',{domProps:{"innerHTML":_vm._s(_vm.urlContent)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }